import React from 'react';
import get from 'lodash/get';
import Creative from './Creative';
import CMP from './CMP';
import HTML from './HTML';

const Viewer = ({
  iframeContents,
  sendAppOpenedEvent,
  cardStyle,
  type,
  firedPixels,
  ad,
  iframeBlockerStyle,
  celtraFixes,
  openCeltra,
  iframeStyle,
  didFinishLoad,
  logTagLoadError,
  cardIframe,
  componentName,
  cardViewState,
  iframeSrc,
}) => (
  <div style={cardStyle}>
    <div id="Card_0_blocker" style={iframeBlockerStyle} />
    {(() => {
      console.log("type on switch: ", type)
      switch (type) {
        case 'image_upload':
        case 'creative':
          return (
            <Creative
              ad={ad}
              componentName={componentName}
              didFinishLoad={didFinishLoad}
              logTagLoadError={logTagLoadError}
              firedPixels={firedPixels}
              iframeSrc={iframeSrc}
              creative={iframeContents}
              style={iframeStyle}
            />
          );
        case 'non_native':
          return (
            <HTML
              parentRef={cardIframe}
              cardViewState={cardViewState}
              celtraFixes={celtraFixes}
              openCeltra={openCeltra}
              sendAppOpenedEvent={sendAppOpenedEvent}
              componentName={componentName}
              ad={ad}
              iframeSrc={iframeSrc}
              creative={iframeContents}
              style={iframeStyle}
              didError={evt => {
                logTagLoadError('CardView.render', 'IFRAME_LOAD_ONERROR', evt);
              }}
              didFinishLoad={didFinishLoad}
            />
          );
        case 'html':
        case 'cmp_tag':
        case 'cmp':
          return (
            <CMP
              parentRef={cardIframe}
              cardViewState={cardViewState}
              celtraFixes={celtraFixes}
              openCeltra={openCeltra}
              sendAppOpenedEvent={sendAppOpenedEvent}
              componentName={componentName}
              ad={ad}
              iframeSrc={iframeSrc}
              creative={iframeContents}
              style={iframeStyle}
              didError={evt => {
                logTagLoadError('CardView.render', 'IFRAME_LOAD_ONERROR', evt);
              }}
              didFinishLoad={didFinishLoad}
            />
          );
        default:
          if (get(iframeContents, 'error')) {
            console.warn('Bad iframe contents', iframeContents);
            return null;
          }
          console.log('>>>>> Viewer.iframe mounted');
          return (
            <iframe
              style={iframeStyle}
              title={componentName}
              id={componentName}
              src={iframeSrc}
              width="100%"
              height="100%"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              scrolling={ad.scrollable ? 'yes' : 'no'}
              seamless="seamless"
              onLoad={didFinishLoad}
              onError={evt => {
                logTagLoadError('CardView.render', 'IFRAME_LOAD_ONERROR', evt);
              }}
              ref={cardIframe}
            />
          );
      }
    })()}
  </div>
);

export default Viewer;
